"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagFormatConfiguration = exports.tagformatConfig = void 0;

var Configuration_js_1 = require("../Configuration.js");

var Tags_js_1 = require("../Tags.js");

var tagID = 0;

function tagformatConfig(config, jax) {
  var tags = jax.parseOptions.options.tags;

  if (tags !== 'base' && config.tags.hasOwnProperty(tags)) {
    Tags_js_1.TagsFactory.add(tags, config.tags[tags]);
  }

  var TagClass = Tags_js_1.TagsFactory.create(jax.parseOptions.options.tags).constructor;

  var TagFormat = function (_super) {
    __extends(TagFormat, _super);

    function TagFormat() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    TagFormat.prototype.formatNumber = function (n) {
      return jax.parseOptions.options.tagformat.number(n);
    };

    TagFormat.prototype.formatTag = function (tag) {
      return jax.parseOptions.options.tagformat.tag(tag);
    };

    TagFormat.prototype.formatId = function (id) {
      return jax.parseOptions.options.tagformat.id(id);
    };

    TagFormat.prototype.formatUrl = function (id, base) {
      return jax.parseOptions.options.tagformat.url(id, base);
    };

    return TagFormat;
  }(TagClass);

  tagID++;
  var tagName = 'configTags-' + tagID;
  Tags_js_1.TagsFactory.add(tagName, TagFormat);
  jax.parseOptions.options.tags = tagName;
}

exports.tagformatConfig = tagformatConfig;
exports.TagFormatConfiguration = Configuration_js_1.Configuration.create('tagformat', {
  config: [tagformatConfig, 10],
  options: {
    tagformat: {
      number: function number(n) {
        return n.toString();
      },
      tag: function tag(_tag) {
        return '(' + _tag + ')';
      },
      id: function id(_id) {
        return 'mjx-eqn:' + _id.replace(/\s/g, '_');
      },
      url: function url(id, base) {
        return base + '#' + encodeURIComponent(id);
      }
    }
  }
});